import { render, staticRenderFns } from "./SocialFusionEmbed.vue?vue&type=template&id=2b757440&scoped=true"
import script from "./SocialFusionEmbed.vue?vue&type=script&lang=js"
export * from "./SocialFusionEmbed.vue?vue&type=script&lang=js"
import style0 from "./SocialFusionEmbed.vue?vue&type=style&index=0&id=2b757440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b757440",
  null
  
)

export default component.exports